import logo from '../../assets/images/logo/logo.png';

const appTextContent = {
  backToHome: {
    link: '/',
    btnClass: 'btn btn-icon btn-primary',
    icon: 'arrow-left',
  },
  logo: {
    link: '#',
    imageSrc: logo,
    alt: 'Logo',
  },
  title: 'App Coming Soon...',
  description: `Start working with Subul Contracting Company that can provide everything
    you need to ensure your home's comfort and efficiency. 
    Experience top-notch heating, cooling, and ventilation solutions.`,
  goBackHomeBtn: {
    link: '/',
    btnClass: 'btn btn-primary mt-4',
    iconClass: 'mdi mdi-backup-restore',
    text: 'Go Back Home',
  },
};

export { appTextContent }